const normalizePricingMode = (value) => String(value || '').trim().toLowerCase();

export const isRangePriced = (item) => (
  normalizePricingMode(item?.pricingMode) === 'range'
  || (item?.minimumPrice != null && item?.maximumPrice != null)
);

export const isRangePriceFinalized = (item) => (
  !isRangePriced(item)
  || item?.isPriceFinalized === true
  || item?.finalUnitPrice != null
);

export const getPriceRange = (item) => {
  const minimum = Number(item?.minimumPrice ?? item?.baseUnitPrice ?? item?.price ?? item?.unitPrice) || 0;
  const maximum = Number(item?.maximumPrice ?? minimum) || minimum;
  return { minimum, maximum };
};

export const getEffectiveUnitPrice = (item) => {
  if (isRangePriced(item) && isRangePriceFinalized(item)) {
    return Number(item?.finalUnitPrice ?? item?.unitPrice ?? item?.price) || 0;
  }
  return Number(item?.unitPrice ?? item?.price ?? item?.minimumPrice ?? item?.baseUnitPrice) || 0;
};

export const formatGhs = (value) => `GH\u00A2${(Number(value) || 0).toLocaleString('en-GH', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;

export const formatItemPrice = (item) => {
  if (!isRangePriced(item) || isRangePriceFinalized(item)) {
    return formatGhs(getEffectiveUnitPrice(item));
  }
  const { minimum, maximum } = getPriceRange(item);
  return `${formatGhs(minimum)} \u2013 ${formatGhs(maximum)}`;
};

export const needsPriceFinalization = (record) => (
  record?.requiresPriceFinalization === true
  || (record?.items || []).some((item) => isRangePriced(item) && !isRangePriceFinalized(item))
);

export const hasRangePricedItems = (items = []) => items.some(isRangePriced);

